import { render } from "./UserProfileContributions.vue?vue&type=template&id=a91a13fc&scoped=true"
import script from "./UserProfileContributions.vue?vue&type=script&lang=js"
export * from "./UserProfileContributions.vue?vue&type=script&lang=js"

import "./UserProfileContributions.vue?vue&type=style&index=0&id=a91a13fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a91a13fc"]])

export default __exports__